import React, { useState, useEffect } from "react";
import moment from "moment";
import {
    LineChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    ReferenceArea,
    ReferenceLine,
    Tooltip
} from 'recharts';
import {
    ConvertData, CustomTooltip, getGroupedSeriesByUUID, getGroupedSeriesByGroupmentAndSerie,
    GetXLSXData, createOccupationArea, CustomizedReferenceLabel, convertUrlColorToHexa
} from './ChartsV2Functions';
import "./ChartV2.css";
import uuid from "react-uuid";

export default function ChartV2LineTimeAxisLive(props) {
    const { chart, displayeddata } = props;
    console.log(chart)
    if(!chart)
        return;
    chart.series.forEach((serie) => {
        serie.uuid = uuid();
        serie.color = convertUrlColorToHexa(serie.color);
        // console.log(serie.color);
    });
    console.log(displayeddata);
    // console.log(chart);
    return (
        <>

            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    width={500}
                    height={300}
                    //data={displayeddata}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 40,
                    }}

                >
                    <defs>
                        <linearGradient id="greentored" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#8bbc21" stopOpacity={1} />
                            <stop offset="100%" stopColor="#c42525" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <defs>
                        <linearGradient id="redtogreen" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#c42525" stopOpacity={1} />
                            <stop offset="100%" stopColor="#8bbc21" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid
                        strokeDasharray="1"
                        vertical={false}
                    />
                    <XAxis
                        allowDataOverflow={true}
                        dataKey="date"
                        type='number'
                        domain={["auto", "auto"]}
                        scale='time'
                        tickFormatter={(unixTime) => chart.xaxistimetick === 'hour' ? moment(unixTime).utc().format('HH:mm') : chart.xaxistimetick === 'second' ? moment(unixTime).utc().format('HH:mm:ss') : chart.xaxistimetick === 'day' ? moment(unixTime).utc().format('DD/MM/yyyy')
                            : chart.xaxistimetick === 'month' ? moment(unixTime).utc().format('MM/yyyy') : moment(unixTime).utc().format('DD/MM/yyyy')}
                        // tick={{ stroke: '#f0f0f0', strokeWidth: 0.1}}
                        name='Date'
                        padding={'gap'}
                        angle={325}
                        tickMargin={25}
                        axisLine={false}
                        minTickGap={50}
                        tick={false}
                    />
                    <YAxis
                        allowDataOverflow={true}
                        label={{ value: chart.yaxis1unit, angle: -90, position: 'insideLeft', stroke: '#f0f0f0', strokeWidth: 0.1}}
                        yAxisId="left"
                        // scale="log"
                        orientation="left"
                        axisLine={false}
                        tickLine={false}
                        // tick={{ stroke: '#f0f0f0', strokeWidth: 0.1}}
                        type="number"
                        // interval='equidistantPreserveStart'
                        domain={[0, 100]}
                        // domain={[(min) => {
                        //     return min > 0 ? 0 : min;
                        // }, "auto"]}
                        // domain={([dataMin, dataMax]) => { 
                        //     const dif = (dataMax-dataMin)/10;
                        //     let min = 0;
                        //     if(dataMin>=0 && dataMin-dif<0)
                        //         min = 0;
                        //     else min = dataMin-dif;
                        //     let max = dataMax+dif;
                        //     return [Math.floor(min), Math.ceil(max)]; 
                        // }}
                        tickFormatter={(value) => value > 10000 ? new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value / 1000) + "k" : "" + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value)}
                    />
                    {
                        chart.yaxis2 ?
                            <YAxis
                                allowDataOverflow={true}
                                label={{ value: chart.yaxis2unit, angle: -90, position: 'insideRight' }}
                                yAxisId="right"
                                orientation="right"
                                axisLine={false}
                                tickLine={false}
                                domain={["auto", "auto"]}
                                tickFormatter={(value) => value > 10000 ? (value / 1000) + "k" : "" + value}
                            /> : <></>
                    }
                    {/* <Tooltip
                        cursor={{ fill: 'transparent' }}
                        content={<CustomTooltip xaxistimetick={chart.xaxistimetick} />}
                    /> */}

                    <Legend
                        wrapperStyle={{ marginBottom: -40 }}
                    />
                    {
                        chart.series.map((serie) =>

                            <Line
                                type="monotone"
                                connectNulls
                                isAnimationActive={false}
                                background={false}
                                data={displayeddata[serie.dataid]}
                                dataKey="value"
                                dot={false}
                                strokeWidth={2}
                                stroke={serie.color}
                                name={serie.name}
                                yAxisId={serie.yaxis || 'left'}
                                unit={(serie.yaxis && serie.yaxis === 'right') ? chart.yaxis2unit : chart.yaxis1unit}
                            />
                        )
                    }

                </LineChart>

            </ResponsiveContainer>
        </>
    );
}